import { Type } from 'class-transformer';
import { SORespRelationshipAttribute } from '../relationship-attribute/so-resp-relationship-attribute';
import { SORespProject } from '../project/so-resp-project';
import { SORespOrganization } from '../organization/so-resp-organization';
import {ENAttributePermissionType} from '../../enums';
import {ObjectiveProtocol} from 'lionheartland';
import {RelationshipAttributePermission} from "../../dexie/db";

export class SORespRelationshipAttributePermission implements ObjectiveProtocol {

  entityType: string = 'relationshipAttributePermission';
  uid: string;
  name: string;
  description: string = "";
  whiteList: boolean;
  permissionType: ENAttributePermissionType;
  @Type(() => SORespRelationshipAttribute)
  relationshipAttribute: SORespRelationshipAttribute = null;
  @Type(() => SORespProject)
  project: SORespProject;
  @Type(() => SORespOrganization)
  organization: SORespOrganization;

    toRelationshipAttributePermission(): RelationshipAttributePermission {
        return {
            uid: this.uid,
            name: this.name,
            description: this.description,
            dateCreated: null,
            whiteList: this.whiteList,
            permissionType: this.permissionType,
            relationshipAttributeUid: this.relationshipAttribute ? this.relationshipAttribute.uid : null,
            relationshipAttributePermissionRulesUid: null,
            rolePermissionsUid: null,
            projectUid: this.project ? this.project.uid : null,
            organizationUid: this.organization ? this.organization.uid : null,
}

        };
}